import React, { useEffect, useState, useCallback } from 'react'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Select from 'react-select'

export default function UsuariosConfig(props) {
    const [numeroIdentificacion, setNumeroIdentificacion] = useState('')
    const [primerNombre, setPrimerNombre] = useState('')
    const [segundoNombre, setSegundoNombre] = useState('')
    const [primerApellido, setPrimerApellido] = useState('')
    const [segundoApellido, setSegundoApellido] = useState('')
    const [codigoUsuario, setCodigousuario] = useState('')
    const [email, setEmail] = useState('')
    const [sexo, setSexo] = useState('')
    const [fechaNacimiento, setFechaNacimiento] = useState('')
    const [esActivo, setEsActivo] = useState('')
    const [rolUser, setRolUSer] = useState('')
    const [empresaId, setEmpresaId] = useState('')
    const [objEmpresa, setObjEmpresa] = useState([])
    const [roles, setRoles] = useState([])

    const getEmpresa = useCallback(async (idEmpresa, page, perPage) => {
        const resp = await ConfiguracionLogic.empresasLogic(idEmpresa, page, perPage, '')
        if (resp.success) {
            const areas = resp.data
                .filter(area => area.Nombre && area.Nombre.trim() !== '')
                .map(area => ({
                    value: area.id,
                    label: area.Nombre
                }))
            setObjEmpresa(areas)
        }
    }, [])

    useEffect(() => {
        getEmpresa(0, 1, 100)
        const storedRoles = localStorage.getItem('rolResp');
        if (storedRoles) {
            setRoles(JSON.parse(storedRoles));
        }
        let fechaNacimiento;

        if (localStorage.getItem("userNumIden")) {
            setNumeroIdentificacion(localStorage.getItem("userNumIden"));
            setPrimerNombre(localStorage.getItem("userPNombre"));
            setSegundoNombre(localStorage.getItem("userSNombre"));
            setPrimerApellido(localStorage.getItem("userPApellido"));
            setSegundoApellido(localStorage.getItem("userSApellido"));
            setCodigousuario(localStorage.getItem("UserCodUser"));
            setEmail(localStorage.getItem("userEmail"));
            setSexo(localStorage.getItem("sexoUBI"));
            setEsActivo(localStorage.getItem("estadoUBI"));
            setEmpresaId(localStorage.getItem("empresaUBI"));

            fechaNacimiento = localStorage.getItem("userFNaci");

            if (fechaNacimiento && fechaNacimiento.includes("/")) {
                const [day, month, year] = fechaNacimiento.split("/");
                fechaNacimiento = `${year}-${month}-${day}`;
            }
            setFechaNacimiento(fechaNacimiento);
        } else if (props.formData.data) {
            const datForm = props.formData.data;
            setNumeroIdentificacion(datForm["identificacion"]);
            setPrimerNombre(datForm["primerNombre"]);
            setSegundoNombre(datForm["segundoNombre"]);
            setPrimerApellido(datForm["primerApellido"]);
            setSegundoApellido(datForm["segundoApellido"]);
            setCodigousuario(datForm["codigo"]);
            setEmail(datForm["email"]);
            setSexo(datForm["sexo"]);

            fechaNacimiento = datForm["nacimiento"];

            if (fechaNacimiento.includes("/")) {
                const [day, month, year] = fechaNacimiento.split("/");
                fechaNacimiento = `${year}-${month}-${day}`;
            }
            setFechaNacimiento(fechaNacimiento);
            setEsActivo(datForm["esActivo"]);
            setEmpresaId(datForm["idEmpresa"]);

            localStorage.setItem("userNumIden", datForm["identificacion"]);
            localStorage.setItem("userPNombre", datForm["primerNombre"]);
            localStorage.setItem("userSNombre", datForm["segundoNombre"]);
            localStorage.setItem("userPApellido", datForm["primerApellido"]);
            localStorage.setItem("userSApellido", datForm["segundoApellido"]);
            localStorage.setItem("UserCodUser", datForm["codigo"]);
            localStorage.setItem("userEmail", datForm["email"]);
            localStorage.setItem("sexoUBI", datForm["sexo"]);
            localStorage.setItem("userFNaci", fechaNacimiento);
            localStorage.setItem("estadoUBI", datForm["esActivo"]);
            localStorage.setItem("empresaBUI", datForm["idEmpresa"]);
        }
    }, [props, getEmpresa]);

    const handleNumberChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir números
        if (/^\d*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    const handleTextChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir letras y espacios
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    const normalChange = (e, setter, storageKey) => {
        const value = e.target.value;
        setter(value);
        localStorage.setItem(storageKey, value);
    };

    return (
        <div className="row justify-content-center">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Identificación</label>
                            <input
                                id="identificacion"
                                name="identificacion"
                                maxLength={13}
                                value={numeroIdentificacion}
                                onChange={e => handleNumberChange(e, setNumeroIdentificacion, 'userNumIden')}
                                className="form-control"
                                placeholder="Ingresar identificación"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Código</label>
                            <input
                                id="codigo"
                                name="codigo"
                                maxLength={13}
                                type='text'
                                value={codigoUsuario}
                                onChange={e => normalChange(e, setCodigousuario, 'UserCodUser')}
                                className="form-control"
                                placeholder="Ingresar RUC"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Primer Nombre</label>
                            <input
                                id="pNombre"
                                name="pNombre"
                                maxLength={100}
                                type="text"
                                value={primerNombre}
                                onChange={e => handleTextChange(e, setPrimerNombre, 'userPNombre')}
                                className="form-control"
                                placeholder="Ingresar su nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Segundo Nombre</label>
                            <input
                                id="sNombre"
                                name="sNombre"
                                maxLength={100}
                                type="text"
                                value={segundoNombre}
                                onChange={e => handleTextChange(e, setSegundoNombre, 'userSNombre')}
                                className="form-control"
                                placeholder="Ingresar Segundo nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Primer Apellido</label>
                            <input
                                id="pApellido"
                                name="pApellido"
                                maxLength={1000}
                                type="text"
                                value={primerApellido}
                                onChange={e => handleTextChange(e, setPrimerApellido, 'userPApellido')}
                                className="form-control"
                                placeholder="Ingresar Apellido"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Segundo Apellido</label>
                            <input
                                id="sApellido"
                                name="sApellido"
                                maxLength={1000}
                                type="text"
                                value={segundoApellido}
                                onChange={e => handleTextChange(e, setSegundoApellido, 'userSApellido')}
                                className="form-control"
                                placeholder="Ingresar segundo apellido"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Fecha nacimiento</label>
                            <input
                                id="fNacimiento"
                                name="fNacimiento"
                                type="date"
                                value={fechaNacimiento}
                                onChange={e => {
                                    setFechaNacimiento(e.target.value);
                                    localStorage.setItem('userFNaci', e.target.value);
                                }}
                                className="form-control"
                                placeholder="Ingresar fecha de nacimiento"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                id="email"
                                name="email"
                                maxLength={1000}
                                type="text"
                                value={email}
                                onChange={e => {
                                    setEmail(e.target.value);
                                    localStorage.setItem('userEmail', e.target.value);
                                }}
                                className="form-control"
                                placeholder="Ingresar Email"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Sexo</label>
                            <select
                                className="form-control"
                                id="sexo"
                                name="sexo"
                                value={sexo}
                                onChange={e => {
                                    setSexo(e.target.value);
                                    localStorage.setItem('sexoUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar Sexo</option>
                                <option value="M">Masculino</option>
                                <option value="F">Femenino</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Empresa</label>
                            <select
                                className="form-control"
                                name="empresa"
                                id="empresa"
                                value={empresaId}
                                onChange={e => {
                                    setEmpresaId(e.target.value);
                                    localStorage.setItem('empresaUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccione una empresa</option>
                                {objEmpresa.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Estado</label>
                            <select
                                className="form-control"
                                id="estado"
                                name="estado"
                                value={esActivo}
                                onChange={e => {
                                    setEsActivo(e.target.value);
                                    localStorage.setItem('estadoUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar estado</option>
                                <option value="S">Activo</option>
                                <option value="N">Inactivo</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Rol</label>
                            <select
                                className="form-control"
                                id="rol"
                                name="rol"
                                value={rolUser}
                                onChange={e => {
                                    setRolUSer(e.target.value);
                                    localStorage.setItem('rolUBI', e.target.value);
                                }}
                            >
                                <option value="">Seleccionar rol</option>
                                {roles.map(rol => (
                                    <option key={rol.id} value={rol.Codigo}>
                                        {rol.Descripcion}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
